const minute_to_coefficients = {
  0: [0.03795094764141569, 0.0],
  1: [0.039022777952512445, 0.0006748066460100649],
  2: [0.03986221486086725, 0.0006313443930015274],
  3: [0.02984158460459137, 0.0006756807898787062],
  4: [0.031213668026046946, 0.0006851266385888945],
  5: [0.035581235094350745, 0.0006663957079283792],
  6: [0.03372218760548854, 0.0006337352933497111],
  7: [0.03272142276415683, 0.000600636356777578],
  8: [0.029219002736945096, 0.0005729832763634163],
  9: [0.026178722136747313, 0.0005472905215161432],
  10: [0.0270926283185593, 0.0005295297864015636],
  11: [0.02852264229388636, 0.0005036951733320813],
  12: [0.027121388982138492, 0.00047804826539964184],
  13: [0.02563979108179546, 0.00045596689782983503],
  14: [0.02474931746361398, 0.00043166089131353556],
  15: [0.022780265873870227, 0.0004101082589418565],
  16: [0.01712164196975311, 0.0003961695040603934],
  17: [0.01401486011293876, 0.000383215588692555],
  18: [0.012206167219039818, 0.0003762775971158963],
  19: [0.011432568644418023, 0.0003749300271176365],
  20: [0.009856518879542038, 0.0003750985266481079],
  21: [0.006827087071790874, 0.0003762707289495728],
  22: [0.005940156587944265, 0.00037638085491766525],
  23: [0.006107639036353821, 0.00037557631549595095],
  24: [0.009231830507071551, 0.0003742085893348302],
  25: [0.010858022416232172, 0.0003732243564464205],
  26: [0.011093541957255405, 0.00037164580589400884],
  27: [0.007820488234794632, 0.0003713473959205648],
  28: [0.007915972127690378, 0.00036999295840110796],
  29: [0.01028425492528397, 0.00036873874932297695],
  30: [0.01408703496219951, 0.0003655785369774505],
  31: [0.01695787968281638, 0.0003625182698185152],
  32: [0.02053362808555883, 0.0003590967919917114],
  33: [0.022321919070415377, 0.0003540116863316686],
  34: [0.025132870169391128, 0.00034622780982588095],
  35: [0.027622885856660458, 0.0003372213525867088],
  36: [0.032142135645634666, 0.000327932632825245],
  37: [0.0351093786772888, 0.00031727341487477106],
  38: [0.03530144741636076, 0.0003054317737461554],
  39: [0.034059172426062184, 0.0002934972392636478],
  40: [0.036156505817284273, 0.0002799334104022684],
  41: [0.033252721396503024, 0.00026493457683626575],
  42: [0.037594212030336756, 0.0002529942744680356],
  43: [0.03614566190707134, 0.00023942616605986892],
  44: [0.04184611193699716, 0.00022432981313201327],
  45: [0.038073134055897635, 0.00020943305224473054],
  46: [0.03829374626927543, 0.00019585189091340143],
  47: [0.029513427197619888, 0.00018281122354784452],
  48: [0.021996014434196735, 0.00016865525079467166],
  49: [0.010339958356834038, 0.00015370167747742354],
  50: [0.016758211453238796, 0.0001406769342557477],
  51: [0.026552563415099307, 0.0001305647898198294],
  52: [0.02120575237299409, 0.00012633630387746532],
  53: [0.02710580789496026, 0.00011419991674804165],
  54: [0.036804102703253815, 0.00010320488594168408],
  55: [0.06950345169607944, 9.240040597411824e-5],
  56: [0.06161153954217668, 8.759750653853591e-5],
  57: [0.10518138980854586, 8.066317086001252e-5],
  58: [0.07118105917061586, 5.9052284646892696e-5],
  59: [0.055747340687445926, 3.8515581877291074e-5],
  60: [0.039643352264987844, 4.422709829875687e-5],
  61: [0.012851530821075624, 4.579579748941325e-5],
  62: [0.03981042535079896, 4.395342183965196e-5],
  63: [-0.11201133553832346, 2.1254409769809318e-5],
  64: [-0.03853078216423719, 2.1081950820950986e-5],
  65: [0.1539142269640121, 1.270223634611258e-5],
  66: [0.19471132842499983, 7.881946651375098e-6],
  67: [0.2565791842426285, 3.977325689708846e-5],
  68: [0.18315193598904053, 1.3720859055037823e-5],
  69: [-0.060069136551574566, 1.4196086200117252e-5],
  70: [0.020430046997022076, 2.0604334910605404e-5],
};

export function calcWinProbability(minute: number, goldLead: number) {
  const coefficients = minute_to_coefficients[minute];
  return 1 / (1 + Math.exp(-(coefficients[0] + coefficients[1] * goldLead)));
}
